import { firefuncs } from "config/firebase";
import { httpsCallable } from "firebase/functions";

const removeFromWaitlist = async (
  gameId: string,
  userId: string,
): Promise<void> => {
  const removeFromWait = httpsCallable(firefuncs, "removeFromWaitlist");

  try {
    const res = await removeFromWait({
      gameId,
      id: userId,
    });
    console.log("Removed from waitlist:", (res.data as any)?.message);
  } catch (error: any) {
    console.error("Error removing from waitlist:", error);

    // Handle Firebase Cloud Functions HttpsError codes
    if (error.code === "functions/invalid-argument") {
      throw new Error(error.message || "Invalid game ID or user ID");
    }
    if (error.code === "functions/not-found") {
      throw new Error(error.message || "Game or waitlist entry not found");
    }
    if (error.code === "functions/permission-denied") {
      throw new Error("Permission denied");
    }
    if (error.code === "functions/unauthenticated") {
      throw new Error("Authentication required");
    }
    if (error.code === "functions/internal") {
      throw new Error(error.message || "Internal server error");
    }

    // Re-throw other errors
    throw error;
  }
};

export default {
  removeFromWaitlist,
};
